import React, { useState } from 'react';
import { 
  KeyOutlined,
  CopyOutlined,
  CheckOutlined,
  CodeOutlined
} from '@ant-design/icons';

export const ApiKeys: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const sandboxKey = 'dev_api_key';
  const tenantId = 'test-tenant';

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">
          Developer API Portal
        </h1>
        <p className="text-slate-500 text-sm">
          Integrate BaZi computation engine directly into your custom HRIS (Odoo, Talenta, BambooHR, etc.).
        </p>
      </div>

      {/* Keys List */}
      <div className="bg-white border border-slate-200 rounded-lg p-5 shadow-sm space-y-4">
        <h3 className="text-sm font-bold uppercase tracking-wider text-slate-500 flex items-center gap-1.5">
          <KeyOutlined style={{ fontSize: 16, color: '#4f46e5' }} />
          Active API Credentials
        </h3>

        <div className="space-y-4">
          <div className="p-4 bg-slate-50 border border-slate-200 rounded-md flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div className="space-y-1">
              <strong className="text-sm text-slate-800 block">Default Sandbox API Key</strong>
              <div className="font-mono text-xs text-slate-500 flex items-center gap-2 bg-white px-2 py-1 rounded border border-slate-200 select-all">
                {sandboxKey}
              </div>
            </div>
            <button
              onClick={() => copyToClipboard(sandboxKey)}
              className="flex items-center gap-1.5 px-3 py-1.5 border border-slate-250 hover:bg-slate-50 text-slate-700 font-semibold text-xs rounded transition-colors"
            >
              {copied ? <CheckOutlined style={{ fontSize: 14, color: '#059669' }} /> : <CopyOutlined style={{ fontSize: 14 }} />}
              {copied ? 'Copied!' : 'Copy Key'}
            </button>
          </div>

          <div className="p-4 bg-slate-50 border border-slate-200 rounded-md flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div className="space-y-1">
              <strong className="text-sm text-slate-800 block">Tenant Identifier (X-Tenant-Id)</strong>
              <div className="font-mono text-xs text-slate-500 flex items-center gap-2 bg-white px-2 py-1 rounded border border-slate-200 select-all">
                {tenantId}
              </div>
            </div>
            <button
              onClick={() => copyToClipboard(tenantId)}
              className="flex items-center gap-1.5 px-3 py-1.5 border border-slate-250 hover:bg-slate-50 text-slate-700 font-semibold text-xs rounded transition-colors"
            >
              <CopyOutlined style={{ fontSize: 14 }} />
              Copy ID
            </button>
          </div>
        </div>
      </div>

      {/* Docs Quick Reference */}
      <div className="bg-slate-900 text-slate-100 border border-slate-950 rounded-lg p-5 shadow-md space-y-4 font-mono text-xs">
        <h3 className="font-bold text-sm text-white flex items-center gap-1.5 pb-2 border-b border-slate-800">
          <CodeOutlined style={{ fontSize: 16, color: '#818cf8' }} />
          API Request Quick Reference
        </h3>

        <div className="space-y-3">
          <div>
            <span className="text-indigo-400 font-bold"># Endpoint 1: Screen Candidate / Compute Chart</span>
            <pre className="bg-slate-950 p-3 rounded mt-1 border border-slate-800 overflow-x-auto select-all">
{`curl -X POST http://localhost:8080/v1/charts \\
  -H "Authorization: Bearer ${sandboxKey}" \\
  -H "X-Tenant-Id: ${tenantId}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "date_of_birth": "1992-04-12",
    "time_of_birth": "10:30",
    "timezone": "Asia/Jakarta",
    "person_name": "Dian Permata",
    "gender": "female"
  }'`}
            </pre>
          </div>

          <div>
            <span className="text-emerald-400 font-bold"># Endpoint 2: Batch Screen Candidates</span>
            <pre className="bg-slate-950 p-3 rounded mt-1 border border-slate-800 overflow-x-auto select-all">
{`curl -X POST http://localhost:8080/v1/candidates/batch \\
  -H "Authorization: Bearer ${sandboxKey}" \\
  -H "X-Tenant-Id: ${tenantId}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "candidates": [
      { "person_name": "Joko", "date_of_birth": "1987-12-05", "time_of_birth": "08:30", "timezone": "Asia/Jakarta", "job_title": "PM" }
    ]
  }'`}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ApiKeys;
